const LinkLogoLinkedin = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="21.813" height="22.188" viewBox="0 0 21.813 22.188">
            <path id="Icon_awesome-linkedin" data-name="Icon awesome-linkedin" d="M20.254,2.25H1.553A1.579,1.579,0,0,0,0,3.85V22.838a1.579,1.579,0,0,0,1.553,1.6h18.7a1.583,1.583,0,0,0,1.558-1.6V3.85A1.583,1.583,0,0,0,20.254,2.25ZM6.592,21.268H3.36V10.68H6.6V21.268ZM4.976,9.233A1.907,1.907,0,1,1,6.85,7.327,1.892,1.892,0,0,1,4.976,9.233ZM18.711,21.268H15.478V16.118c0-1.228-.024-2.808-1.68-2.808-1.685,0-1.943,1.337-1.943,2.719v5.24H8.623V10.68h3.1v1.446h.044a3.4,3.4,0,0,1,3.063-1.709c3.272,0,3.88,2.194,3.88,5.047Z" transform="translate(0 -2.25)" fill="#e2e2e2"/>
        </svg>
    )
  }
  
export default LinkLogoLinkedin